import { insertOrUpdateBlock } from "@blocknote/core";
import type { DefaultReactSuggestionItem } from "@blocknote/react";
import type { BnEditor } from "blocks-schema";
import { Icon, iconStyles } from "ui";

export function insertVideoBlockItems(editor: BnEditor): DefaultReactSuggestionItem[] {
  return [
    {
      title: "Video",
      onItemClick: () => {
        editor.transact(() => {
          const block = insertOrUpdateBlock(editor, {
            type: "videoBlock",
            props: {
              videoUrl: "",
            },
          });
          editor.setTextCursorPosition(block);
        });
      },
      aliases: ["video", "youtube", "vimeo", "embed"],
      group: "Content",
      icon: <Icon className={iconStyles.neutral600} iconType="Video" />,
      subtext: "Embed a video from YouTube, Vimeo, or other platforms",
    },
  ];
}
